export default "__VITE_ASSET__ac82f8cf__"